/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
});


// Pricing Boxes
jQuery(document).ready(function( $ ) {

  $(".card-2,.card-3").hover(function() {

			$(".card-1" ).removeClass("small-6").addClass("small-3");

  }, function(){

			$(".card-1" ).removeClass("small-3").addClass("small-6");

	});

	$(".card-2").hover(function() {

			$(".card-2" ).removeClass("small-3").addClass("small-6");

  }, function(){

			$(".card-2" ).removeClass("small-6").addClass("small-3");

	});

	$(".card-3").hover(function() {

			$(".card-3" ).removeClass("small-3").addClass("small-6");

	}, function(){

			$(".card-3" ).removeClass("small-6").addClass("small-3");

	});

});

jQuery(document).ready(function($) {
// 3 Steps mobile slider
  $("#owl-threesteps").owlCarousel({

			navigation : true, // Show next and prev buttons
			autoplay:true,
	    autoplayTimeout:5000,
	    autoplayHoverPause:true,
			slideSpeed : 5000,
			dots: false,
			paginationSpeed : 2000,
			loop: true,
			items: 1,
			nav    : true,
     	navText : ['<i class="fa fa-angle-left" aria-hidden="true"></i>','<i class="fa fa-angle-right" aria-hidden="true"></i>']


	});

});

// Inputs
// jQuery(document).ready(function($) {
// 	$('#fancy-inputs input[type="text"]').blur(function(){
// 	  if($(this).val().length > 0){
// 	    $(this).addClass('white');
// 	  } else {
// 	    $(this).removeClass('white');
// 	  }
// 	});
// });

// Radios
// jQuery(document).ready(function($) {
// 	$("#choice_1_3_0").click(function() {
// 	  $('#label_1_3_0').removeClass('selected');
// 	  var inputID = $(this).attr('id');
// 	  if ($(this).is(':checked')) {
// 	    $('.' + inputID).addClass('selected');
// 	  } else {
// 	    $('.' + inputID).removeClass('selected');
// 	  }
// 	});
// });
